import { useReferralPageContext } from 'contexts/referral';
import { DateTime } from 'luxon';
import { LUXON_MIDNIGHT } from 'utils/date';

export const useGetIsReferralCampaignActive = () => {
  const { referralCampaign } = useReferralPageContext();
  const endDate = DateTime.fromISO(referralCampaign?.endDate as any).set(LUXON_MIDNIGHT);
  return endDate > DateTime.now();
};
